// extracted by mini-css-extract-plugin
export default {"root":"root--mwtt0","body2":"body2--gfozD","seperator":"seperator--lXy34"};